export default __webpack_public_path__ + "content/media/14.19748cd1.jpg";